<template>
    <div id="wrapper">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{ $t('string.msg.menu.request.label.title') }}</h4>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card-box">
                                <b-card no-body>
                                    <b-tabs content-class="mt-3" fill active-nav-item-class="text-uppercase">
                                        <div>
                                            <b-tab active>
                                                <template v-slot:title>
                                                    <i class="dripicons-parts"></i> <strong>{{ '  ' + $t('string.msg.menu.register.parts.label.title') }}</strong>
                                                </template>
                                                <Parts :truckers="truckers" :company="company" />
                                            </b-tab>
                                        </div>

                                        <!-- <div>
                                            <b-tab>
                                                <template v-slot:title>
                                                    <i class="dripicons-service"></i> <strong>{{ '  ' + $t('string.msg.menu.register.services.label.title') }}</strong>
                                                </template>
                                                <Services :truckers="truckers" :company="company" />
                                            </b-tab>
                                        </div>
                                        <div>
                                            <b-tab>
                                                <template v-slot:title>
                                                    <i class="dripicons-book"></i> <strong>{{ '  ' + $t('string.msg.menu.register.certified.label.title') }}</strong>
                                                </template>
                                                <Certifies :truckers="truckers" :company="company" />
                                            </b-tab>
                                        </div> -->
                                    </b-tabs>
                                </b-card>
                            </div>
                            <!-- end card-box-->
                        </div>
                        <!-- end col -->
                    </div>
                </div>
            </div>
        </div>

        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtRequest'
import Spinner from '../../../components/layout/Spinner'
import Toast from '../../../components/layout/Toast'
import Parts from './Part/Part.vue'
import Certifies from './Certifie/Certified.vue'
import Services from './Service/Service.vue'

export default {
    name: 'Request',
    components: {
        Spinner,
        Toast,
        Services,
        Parts,
        Certifies,
    },
    data() {
        return {
            errors: [],
            truckers: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            company: null,
            filters: {
                status: 'ACTIVE',
                name: '',
            },
        }
    },
    methods: Controller.methods,
    created() {
        Controller.init(this)
    },
    mounted() {},
}
</script>

    <style>
</style>
